"use client"
import { springEasing, transitionEase, transitionTime } from "./utils"

const transitionRightValue = "50px"

export const useTransitionRightStyles = (
  $inView: boolean,
  $delay?: number,
  $time?: number,
  $easing?: keyof typeof springEasing,
) => {
  const easingValue = $easing ? springEasing[$easing] : transitionEase

  return {
    PointerEvent: "auto",
    opacity: $inView ? 1 : 0,
    transition: `all ${$time ? $time : transitionTime}s ${easingValue}`,
    transform: $inView
      ? "translateX(0px)"
      : `translateX(${transitionRightValue})`,
    ...(typeof $delay === "number" && { transitionDelay: `${$delay}s` }),
  }
}
